/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Col_EntityInputs */

const en_audit_col_entity = /** @type {(inputs: Audit_Col_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity`)
};

const pt_br2_audit_col_entity = /** @type {(inputs: Audit_Col_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entidade`)
};

/**
* | output |
* | --- |
* | "Entity" |
*
* @param {Audit_Col_EntityInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const audit_col_entity = /** @type {((inputs?: Audit_Col_EntityInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Col_EntityInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_col_entity(inputs)
	return pt_br2_audit_col_entity(inputs)
});